import { generateTestId } from "@client-shared";

export const setCustomersViewTestId = (identifier: string): string =>
  generateTestId("CustomersView", identifier);
